// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React, {useCallback, useState} from 'react';

import * as S from '../EntityReport.styles';

type TeamReadmeModalProps = {onSave: () => void; onClose: () => void};

export const TeamReadmeModal: React.FC<TeamReadmeModalProps> = ({
  onSave,
  onClose,
  children,
}) => {
  const [warningOpen, setWarningOpen] = useState(false);

  const openWarning = useCallback(() => {
    setWarningOpen(true);
  }, []);

  const closeWarning = useCallback(() => {
    setWarningOpen(false);
  }, []);

  return (
    <S.Modal open onClose={openWarning}>
      <S.ModalHeader>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
        <S.ModalCloseIcon name={`close`} onClick={openWarning} />
      </S.ModalHeader>
      {children}
      {warningOpen && (
        <S.ModalWarningOverlay>
          <S.ModalWarningContent>
            <S.ModalWarningText>
              Are you sure you want to exit without saving?
            </S.ModalWarningText>
            <S.ModalWarningActions>
              <Button variant="primary" onClick={closeWarning}>
                Resume
              </Button>
              <Button variant="secondary" onClick={onClose}>
                Exit and discard
              </Button>
            </S.ModalWarningActions>
          </S.ModalWarningContent>
        </S.ModalWarningOverlay>
      )}
    </S.Modal>
  );
};
